<template>
  <div class="common-attachment-upload">
    <a-upload
      :action="action"
      :beforeUpload="_beforeUploadAttachmentList"
      :data="data"
      :fileList="fileList"
      :showUploadList="{showRemoveIcon: false}"
      :multiple="false"
      @change="_handleChangeAttachmentList"
    >
      <a-button size="large" style="margin-right: 8px;">
        <a-icon type="upload"/>
        点击上传
      </a-button>
    </a-upload>
    <div style="color:rgba(0, 0, 0, 0.45);">支持扩展名：.pdf .jpg .JPG .png，最大20M</div>
    <a-table
      :columns="attColumns"
      :dataSource="attachmentList"
      :pagination="false"
      ref="table"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="_delAttachment(record.id)">删除</a>
        <a-divider type="vertical"/>
        <a @click="_download(record)">下载</a>
      </span>
    </a-table>
  </div>
</template>

<script>

  const defaultValidate = {
    // 验证文件类型
    type: {
      reg: /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/,
      msg: '只能上传图片文件'
    },
    // 验证文件大小
    size: {
      mb: 30,
      msg: '单个文件上传最大为30M'
    },
    // 验证文件数量
    count: {
      max: 99,
      msg: '最多上传99个'
    }
  }
  export default {
    name: 'AttachmentUpload',
    props: {
      // 附件上传地址
      action: {
        type: Function
      },
      // 附件上传请求参数
      data: {
        type: Function,
        // eslint-disable-next-line vue/require-valid-default-prop
        default: {}
      },
      // 附件验证
      validate: {
        type: Object,
        default: function() {
          return defaultValidate
        }
      },
      name: {
        type: String
      }
    },
    computed: {
      _validate() {
        return Object.assign(defaultValidate, this.validate)
      }
    },
    data() {
      return {
        attachmentList: [],
        attachmentIdList: [],
        fileList: [],
        attColumns: [
          {
            title: this.name ? this.name : '名称',
            dataIndex: 'name'
          },
          {
            title: '操作',
            width: 160,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    methods: {
      /**
       * 初始化
       * attachmentList :{
       *     id:1 ,
       *     name:'附件名',
       *     url:'附件地址'
       *     thumbUrl:'缩略图附件地址'
       * }
       */
      init(attachmentList) {
        console.log('AttachmentUpload-init:attachmentList:%o', attachmentList)
        this.attachmentList = attachmentList.map(item => {
          return {
            id: item.id,
            uid: item.uid,
            name: item.name,
            status: 'done',
            url: item.url,
            thumbUrl: item.thumbUrl,
            type: item.type,
            // 服务器响应信息:用于模拟上传后状态,设置的参数源于_onUploadChange方法
            response: {
              status: 200,
              result: {
                id: item.uid
              }
            }
          }
        })
        this.attachmentIdList = this.attachmentList.map(item => item.id)
      },
      /**
       * 获取附件列表
       */
      getAttachmentList() {
        console.log('AttachmentUpload-getAttachmentList')
        return this.attachmentList
      },
      /**
       * 获取附件id列表
       */
      getAttachmentIdList() {
        console.log('AttachmentUpload-getAttachmentList')
        return this.attachmentIdList
      },
      _beforeUploadAttachmentList(file, fileList) {
        console.log(this.attachmentList.length)
        if (this.attachmentList.length >= this._validate.count.max) {
          this.$message.error(this._validate.count.msg)
          fileList.pop()
          return false
        }
        if (!this._validate.type.reg.test(file.name)) {
          this.$message.error(this._validate.type.msg)
          fileList.pop()
          return false
        }
        if (file.size >= 1024 * 1024 * this._validate.size.mb) {
          this.$message.error(this._validate.size.msg)
          fileList.pop()
          return false
        }
      },
      _handleChangeAttachmentList({ file, fileList }) {
        console.log('AttachmentUpload-handleChangeAttachmentList:data:%o', { file, fileList })
        fileList.forEach(t => {
          this.fileList = this.fileList.filter(item => item.uid !== t.uid)
          if (t.status === 'uploading') {
            this.fileList.push(t)
          }
          if (t.status === 'done') {
            if (t.response.status === 200) {
              if (this.fileList.length === 0) {
                this.$store.commit('SET_APP_SPINNING', false)
              }
              if (this.attachmentList === null) this.attachmentList = []
              this.attachmentList.push(t.response.result)
              this.attachmentIdList.push(t.response.result.id)
            } else {
              this.$message.error(t.response.message)
            }
          }
        })
      },
      _delAttachment(file) {
        const id = file
        const that = this
        that.attachmentIdList.splice(that.attachmentIdList.findIndex(item => item === id), 1)
        for (let i = 0; i < that.attachmentList.length; i++) {
          if (that.attachmentList[i].id === id) {
            that.attachmentList.splice(i, 1)
          }
        }
      },
      _download(record) {
        location.href = 'http://' + window.location.host + '/base/attachment/downloadAttachment' + '?id=' + record.id
      }
    },
    created() {
      console.log('AttachmentUpload-created:params:%o', {
        action: this.action,
        data: this.data,
        validate: this.validate,
        _validate: this._validate
      })
    }
  }
</script>

<style lang="less">
  .common-attachment-upload {
    .ant-table-placeholder {
      padding: 0 !important;
    }

    .ant-empty-normal {
      margin: 10px 0 !important;
    }
  }
</style>
